<tc-profile-picture [user]="user" [showRole]="true" class="picture"></tc-profile-picture>
<div class="text">
  <div>
    <tc-user-name [user]="user"></tc-user-name>
  </div>
  <small *ngIf="position">
    {{ position }}
  </small>
</div>
